var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_c('h3',{staticClass:"tab-title"},[_vm._v(_vm._s(_vm.$t('tabs.settings.main')))]),_c('SiteOptions')],1),_c('div',{staticClass:"column is-half"},[_c('h3',{staticClass:"tab-title"},[_vm._v(_vm._s(_vm.$t('tabs.settings.templateSection')))]),_c('SectionNames')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }